<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">PWmat</div>
      </div>

      <img
        class="pwmat-introduce-banner-img"
        src="../../assets/about/banner.png"
      />
    </div>
    <div class="pwmat-introduce-container">
      <div class="pwmat-introduce-content">
        <div class="pwmat-introduce-content-title">
          <div class="pwmat-introduce-content-title-text">PWmat简介</div>
          <div class="pwamt-introduce-line"></div>
        </div>
        <div class="pwmat-introduce-content-info">
          <p class="pwmat-introduce-content-info-text">
            PWmat是原子尺度方面的材料模拟软件包，它基于第一性原理，利用平面波基组、赝势方法进行电子结构计算、分子动力学模拟。更重要的是，PWmat使用CUDA进行GPU优化加速，相比相同的CPU软件（PEtot，基于BSD开源授权），达到了20倍的加速，能够在MSTATION上面实现4000电子以上体系的模拟计算。
          </p>
          <p class="pwmat-introduce-content-info-text">
            PWmat能够近似求解多体薛定谔方程得到体系的电子态和能量。在密度泛函理论（DFT）框架内，利用局域密度近似（LDA）、广义梯度近似（GGA）、混合泛函（HSE）近似等方法求解Kohn-Sham方程。
          </p>
          <p class="pwmat-introduce-content-info-text">
            PWmat中的单电子轨道、电子密度、局域势都利用平面波基组展开，电子-离子相互作用通过模守恒赝势或者超软赝势来描述。
          </p>
        </div>

        <div class="pwmat-introduce-content-title">
          <div class="pwmat-introduce-content-title-text">功能特点</div>
          <div class="pwamt-introduce-line"></div>
        </div>
        <div class="pwmat-introduce-content-info">
          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_4.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">交换关联泛函</div>
              <div class="pwmat-introduce-function-desc">
                LDA、GGA、meta-GGA
              </div>
              <div class="pwmat-introduce-function-desc">混合泛函HSE</div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_2.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">
                结构弛豫与分子动力学
              </div>
              <div class="pwmat-introduce-function-desc">晶格和原子弛豫</div>
              <div class="pwmat-introduce-function-desc">第一性MD、NEB</div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_3.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">磁性计算</div>
              <div class="pwmat-introduce-function-desc">
                线性与非线性磁性计算
              </div>
              <div class="pwmat-introduce-function-desc">
                自旋轨道耦合（SOC）
              </div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_1.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">力学性质</div>
              <div class="pwmat-introduce-function-desc">材料状态方程</div>
              <div class="pwmat-introduce-function-desc">材料声子谱</div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_5.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">电子结构</div>
              <div class="pwmat-introduce-function-desc">
                能带结构与电子态密度
              </div>
              <div class="pwmat-introduce-function-desc">电荷密度分布</div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_6.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">兼容PWSCF</div>
              <div class="pwmat-introduce-function-desc">wannier方程</div>
              <div class="pwmat-introduce-function-desc">GW方程</div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_7.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">rt-TDDFT</div>
              <div class="pwmat-introduce-function-desc">
                即时含时密度泛函模拟
              </div>
              <div class="pwmat-introduce-function-desc">
                飞秒级分子动力学加速
              </div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_8.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">电声耦合计算</div>
              <div class="pwmat-introduce-function-desc">
                全新算法描述电子态相互作用
              </div>
              <div class="pwmat-introduce-function-desc">
                defect state、level
              </div>
            </div>
          </div>

          <div class="pwmat-introduce-function">
            <div class="pwmat-introduce-function-img">
              <img src="../../assets/produce/pwmat/cp_tb_9.png" />
            </div>
            <div class="pwmat-introduce-function-text">
              <div class="pwmat-introduce-function-name">solvent溶剂效应</div>
              <div class="pwmat-introduce-function-desc">
                各种液态气态溶剂效应
              </div>
              <div class="pwmat-introduce-function-desc">
                相比传统算法，10倍加速
              </div>
            </div>
          </div>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">PWmat应用</div>
          <div class="pwamt-introduce-line"></div>
        </div>
        <div class="pwmat-introduce-content-info">
          <p class="pwmat-introduce-content-info-text">
            PWmat能够用来解决如下一些问题，这些应用一部分可以直接通过PWmat计算得到，一部分需要基于PWmat的计算结果来分析，而所有这些应用仅依赖于PWmat的核心功能（SCF、NONSCF、DOS、RELAX、MD、NEB）
          </p>
        </div>
        <div class="pwmat-inroduce-application">
          <div class="pwmat-inroduce-application-group-1">
            <p class="pwmat-inroduce-application-text">晶体能带结构</p>
            <p class="pwmat-inroduce-application-text">电子态密度（DOS）</p>
            <p class="pwmat-inroduce-application-text">晶体化合物的形成能</p>
            <p class="pwmat-inroduce-application-text">合金相图</p>
            <p class="pwmat-inroduce-application-text">声子谱</p>
            <p class="pwmat-inroduce-application-text">缺陷形成能和缺陷分析</p>
            <p class="pwmat-inroduce-application-text">表面重构与表面能</p>
            <p class="pwmat-inroduce-application-text">
              分子在表面的吸附与结构
            </p>
            <p class="pwmat-inroduce-application-text">能带修正</p>
            <p class="pwmat-inroduce-application-text">超晶格结构模拟</p>
          </div>

          <div class="pwmat-inroduce-application-group-2">
            <p class="pwmat-inroduce-application-text">量子阱效应</p>
            <p class="pwmat-inroduce-application-text">液体自由能</p>
            <p class="pwmat-inroduce-application-text">
              分子或者离子在液体中的扩散
            </p>
            <p class="pwmat-inroduce-application-text">团簇结构搜索</p>
            <p class="pwmat-inroduce-application-text">晶体结构搜索</p>
            <p class="pwmat-inroduce-application-text">固体热导率</p>
            <p class="pwmat-inroduce-application-text">催化反应与中间态</p>
            <p class="pwmat-inroduce-application-text">
              化学反应路径与反应能量
            </p>
            <p class="pwmat-inroduce-application-text">有机物分子结构</p>
            <p class="pwmat-inroduce-application-text">光学性质计算</p>
          </div>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">性能测试</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/pwmat-resource/pwmatSpeedTest.pdf'"
          >
            速度测试
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/test-document/6'"
          >
            精度测试
          </p>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">一体化解决方案</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/mstation-introduce'"
          >
            Mstation
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/mcluster-introduce'"
          >
            Mcluster
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/mcloud-introduce'"
          >
            Mcloud
          </p>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">软件试用</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='http://longxun2015.mikecrm.com/y72WBOU'"
          >
            申请License试用
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/mcloud-introduce'"
          >
            注册超算云Mcloud试用
          </p>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">软件教程</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toQuikStart"
          >
            快速上手教程
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toTutorials"
          >
            Tutorials
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toCase"
          >
            案例教程
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toTrain"
          >
            视频教程
          </p>
        </div>

        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">相关链接</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toMSTATIONDownload"
          >
            PWmat下载
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toModuleDownload"
          >
            Module下载
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toPotentialDownload"
          >
            赝势下载
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toManual"
          >
            英文手册下载
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="tocnManual"
          >
            中文手册下载
          </p>
          <p
            class="pwmat-introduce-content-info-text2"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='//www.pwmat.com/paper'"
          >
            发表论文
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PWMAT_RESOURCE } from "./../../helpers/consts";
export default {
  name: "companyIntroduce",
  data() {
    return {
      PWMAT_RESOURCE,
    };
  },
  methods: {
    toMSTATIONDownload() {
      this.$router.push({ name: "MSTATIONDownload" });
    },
    toPotentialDownload() {
      this.$router.push({ name: "PotentialDownload" });
    },
    toModuleDownload() {
      this.$router.push({ name: "ModuleDownload" });
    },
    toQuikStart() {
      this.$router.push({ name: "QuickStartTutorial" });
    },
    toTutorials() {
      this.$router.push({ name: "Tutorials" });
    },
    toCase() {
      this.$router.push({ name: "Case" });
    },
    toTrain() {
      this.$router.push({ name: "Train" });
    },
    toManual() {
      window.open(this.PWMAT_RESOURCE + "Manual.pdf");
    },
    tocnManual() {
      window.open(this.PWMAT_RESOURCE + "Manual_cn.pdf");
    },
    toProchureBook() {
      window.open(this.PWMAT_RESOURCE + "prochure.pdf");
    },
    toProchureNewFunctions() {
      window.open(this.PWMAT_RESOURCE + "PWmat_2019_new_functions.pdf");
    },
  },
};
</script>

<style scoped>
.pwmat-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-introduce-background {
  margin-top: 70px;
}
.pwmat-introduce-banner {
  overflow: hidden;
}
.pwmat-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-introduce-content-title {
  padding-top: 50px;
}
.pwmat-introduce-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.pwmat-introduce-content-info {
  margin-top: 40px;
}
.pwmat-introduce-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwmat-introduce-content-info-text2 {
  font-size: 20px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwamt-introduce-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}
.pwmat-introduce-function {
  display: inline-block;
  padding-left: 80px;
  margin-bottom: 50px;
  width: 346px;
}
.pwmat-introduce-function-img {
  display: inline-block;
  vertical-align: top;
}
.pwmat-introduce-function-text {
  display: inline-block;
  vertical-align: top;
  margin-left: 23px;
}
.pwmat-introduce-function-name {
  font-size: 18px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-bottom: 8px;
  margin-top: -6px;
}
.pwmat-introduce-function-desc {
  font-size: 14px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 20px;
}
.pwmat-inroduce-application {
  background: rgba(73, 145, 201, 0.1);
  padding: 24px 99px 27px 99px;
  margin-bottom: 50px;
}
.pwmat-inroduce-application-group-1 {
  width: 539px;
  display: inline-block;
}
.pwmat-inroduce-application-group-2 {
  width: 299px;
  display: inline-block;
}
.pwmat-inroduce-application-text {
  font-size: 16px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(79, 76, 77, 1);
  line-height: 38px;
  margin-bottom: 0;
}
@media screen and (max-width: 482px) {
  .pwmat-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
</style>
